export { default } from "@src/Apps/PricingBiologics";
